import React, { useEffect, useState } from 'react';
import { CalendarioGrid } from './CalendarioGrid';
import { Fab, Box, IconButton, Typography, CircularProgress } from '@mui/material';
import TodayIcon from '@mui/icons-material/Today';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { DndContext } from '@dnd-kit/core';
import { getEstados, getOpcionesTareas, getTareasCalendario } from '../../services/apis';

export const Calendario = () => {
	const [tareas, setTareas] = useState([]);
	const onDragEnd = (event) => {
		const { active, over } = event;
		if (over && active.id) {
			const nuevaFecha = over.id;
			setTareas((prev) =>
				prev.map((t) => (t.id === active.id ? { ...t, fecha: nuevaFecha } : t))
			);
		}
	};
	const hoy = new Date();

	const [anio, setAnio] = useState(hoy.getFullYear());
	const [mes, setMes] = useState(hoy.getMonth());
	const [opcionesTareas, setOpcionesTareas] = useState([]);
	const [estados, setEstados] = useState([]);
	const [loaded, setLoaded] = useState(false);
	const diaHoy = hoy.getDate();
	const mesHoy = hoy.getMonth();
	const anioHoy = hoy.getFullYear();

	const cambiarMes = (delta) => {
		let nuevoMes = mes + delta;
		let nuevoAnio = anio;

		if (nuevoMes < 0) {
			nuevoMes = 11;
			nuevoAnio--;
		} else if (nuevoMes > 11) {
			nuevoMes = 0;
			nuevoAnio++;
		}

		setMes(nuevoMes);
		setAnio(nuevoAnio);

		// Desplazarse al primer día del nuevo mes
		setTimeout(() => {
			const idPrimerDia = `01-${String(nuevoMes + 1).padStart(2, '0')}-${nuevoAnio}`;
			const celda = document.getElementById(idPrimerDia);
			if (celda) {
				celda.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		}, 50); // Esperamos un poco para que el render ocurra
	};
	const irAHoy = () => {
		const idHoy = `${String(diaHoy).padStart(2, '0')}-${String(mesHoy + 1).padStart(2, '0')}-${anioHoy}`;
		const celdaHoy = document.getElementById(idHoy);
		if (celdaHoy) {
			celdaHoy.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
		setMes(mesHoy);
		setAnio(anioHoy);
	};

	const nombreMes = new Date(anio, mes).toLocaleString('es-ES', { month: 'long' });
	const tratarFechasTareas = (tareas) => {
		return tareas.map((tarea) => {
			let fecha = '';
			let hora = '';

			if (tarea.fecha_calen) {
				const [fechaISO, horaStr] = tarea.fecha_calen.split(' ');
				const [anio, mes, dia] = fechaISO.split('-');
				fecha = `${dia}-${mes}-${anio}`;
				hora = horaStr.slice(0, 5); // obtiene HH:mm
			}

			return {
				...tarea,
				fecha,
				hora,
			};
		});
	};

	const tareasCalendario = async () => {
		try {
			const response = await getTareasCalendario();
			setTareas(tratarFechasTareas(response.data));
			console.log(tratarFechasTareas(response.data));


			console.log("sdad", response.data)
		} catch (error) {
			console.error("Error cargar tareas", error)
		}
	}

	const cargarOpcionesTareas = async () => {
		try {
			const response = await getOpcionesTareas(0);
			setOpcionesTareas(response.data);
			setLoaded(true);

		} catch (error) {
			console.error("Error cargar tareas", error)
		}
	}
	useEffect(() => {
		tareasCalendario();
		cargarEstados();
		cargarOpcionesTareas();
		
	}, [])
	const cargarEstados = async () => {
		try {
			const response = await getEstados();
			setEstados(response.data.estados)
		} catch (error) {
			console.error("Error al añadir el cliente:", error);
		}

	}

	return (
		<DndContext onDragEnd={onDragEnd}>
			<div>
				{/* Barra superior con controles */}
				<Box
					position="sticky"
					top={0}
					zIndex={10}
					bgcolor="white"
					boxShadow={2}
					padding={1}
					display="flex"
					justifyContent="space-between"
					alignItems="center"
				>
					<IconButton onClick={() => cambiarMes(-1)}>
						<ArrowBackIos />
					</IconButton>

					<Typography variant="h6" textTransform="capitalize">
						{nombreMes} {anio}
					</Typography>

					<Box display="flex" alignItems="center" gap={1}>
						<IconButton onClick={() => cambiarMes(1)}>
							<ArrowForwardIos />
						</IconButton>
						<Fab size="small" color="primary" onClick={irAHoy} aria-label="Hoy">
							<TodayIcon />
						</Fab>
					</Box>
				</Box>
				{!loaded && (
					<CircularProgress size={40} />
				)}
				{loaded && (
					<>
						<Typography variant="subtitle1" textAlign="center" marginTop={2} marginBottom={2}>
							{tareas.length} tareas
						</Typography>

						{/* Calendario visible */}
						<CalendarioGrid
							hoy={hoy}
							diaHoy={diaHoy}
							mesHoy={mesHoy}
							anioHoy={anioHoy}
							mesActual={mes}
							anioActual={anio}
							tareas={tareas}
							setTareas={setTareas}
							opcionesTareas={opcionesTareas}
							estados={estados}
						/>
					</>)}</div>
		</DndContext>
	);

};
